import React from 'react'
import { Routes, Route } from 'react-router-dom'

import VehiclesIndex from './vehicles_index.jsx'
import VehiclesNew from './vehicles_new.jsx'
import VehiclesEdit from './vehicles_edit.jsx'

let VehiclesRouter = () => (
  <Routes>
    <Route exact path="/"         element={ <VehiclesIndex /> } />
    <Route exact path="/new"      element={ <VehiclesNew /> } />
    <Route       path="/:id/edit" element={ <VehiclesEdit /> } />
  </Routes>
)

export default VehiclesRouter
